<template>
  <div>
    <b-col md="12" class="component-margin">
      <b-row>
        <b-col md="12" class="margin">
          <b-button size="md" @click="bootSpreadsheet()" variant="danger">スプレッドシート起動</b-button>
          <b-button v-if="!imported" @click="importItems()" class="margin-left-5" size="md" variant="danger">データ取込</b-button>
          <b-button v-else size="md" @click="reimportItems()" class="margin-left-5" variant="danger">データ再取込</b-button>
          <b-button v-if="!hasErrors" size="md" @click="registerItemsConfirm()" class="margin-left-5" variant="danger">関税登録実行</b-button>
          <b-button v-else size="md" class="margin-left-5" disabled variant="danger">関税登録実行</b-button>
        </b-col>
      </b-row>
    </b-col>
    <b-col sm="12">
    <b-table show-empty stacked=md bordered=true striped=true small=true hover=true
             :items="items" :fields="fields" :filter="filter"
             :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
      <template slot="customBillingDate" slot-scope="row">
        <label>{{formatDate(row.value)}}</label>
      </template>
      <template slot="customs" slot-scope="row">
        <label>{{formatPrice(row.value)}}</label>
      </template>
      <template slot="lasRegisteredDate" slot-scope="row">
        <label>{{formatDate(row.value)}}</label>
      </template>
      <template slot="status" slot-scope="row">
        <label>{{SpreadSheetStatusText(row.value)}}</label>
      </template>
      <template slot="message" slot-scope="row">
        <ul>
          <li v-for='(value, index) in row.item.messages' :key='index'>
            {{ value }}
          </li>
        </ul>
      </template>
    </b-table>
    </b-col>
    <b-modal ref="registerItemsConfirm" @ok="registerItems" hide-header>
      <div class="text-center">データの取り込みを実施します。</div>
    </b-modal>
    <b-modal ref="messagePopup" ok-only hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import ConditionType from '@/types/ConditionType';
import ExistType from '@/types/ExistType';
import SpreadSheetStatus from '@/types/SpreadSheetStatus';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    deposit: { default: 0},
    requireDeposit: { default: 0},
    isWarnDeposit: { default: false}
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'customBillingDate', label: '請求日', sortable: true, variant: 'base' },
        { key: 'customs', label: '請求額', sortable: true, variant: 'base' },
        { key: 'trackingNumber', label: '追跡番号', sortable: true, variant: 'base' },
        { key: 'lasRegisteredDate', label: 'LAS登録日', sortable: true, variant: 'base' },
        { key: 'memberId', label: '会員番号', sortable: true, variant: 'base' },
        { key: 'name', label: '会員名', sortable: true, variant: 'base' },
        { key: 'status', label: 'Status', sortable: true, variant: 'base' },
        { key: 'message', label: 'メッセージ', sortable: true, variant: 'base' },
      ],
      // currentPage: 1,
      // perPage: 25,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      activate: false,
      imported: false,
      hasErrors: true,
      confirmMessage: '',
    };
  },
  methods: {
    conditionTypeText(item) {
      return ConditionType.valueOf(item).text;
    },
    existTypeText(item) {
      return ExistType.valueOf(item).text;
    },
    SpreadSheetStatusText(item) {
      return SpreadSheetStatus.valueOf(item).text;
    },
    bootSpreadsheet() {
      // ★
      api.getSpreadSheetForCustomUrl((data) => {
        window.open(data.url, '_blank');
      });
    },
    importItems() {
      // ★
      api.getCustomRegistration((data) => {
        this.items = data.customList;
        this.totalRows = this.items.length;
        this.addCellVariant();
        this.imported = true;
        if(data.customInputLimit){
          this.confirmMessage = 'スプレッドシート600行目迄しか取込できません。必要に応じ複数回に分けて取込ください。';
          this.$refs.messagePopup.show();
        }
      });
    },
    reimportItems() {
      // ★
      api.getCustomRegistration((data) => {
        this.items = data.customList;
        this.totalRows = this.items.length;
        this.addCellVariant();
        this.imported = true;
        if(data.customInputLimit){
          this.confirmMessage = 'スプレッドシート600行目迄しか取込できません。必要に応じ複数回に分けて取込ください。';
          this.$refs.messagePopup.show();
        }
      });
    },
    registerItemsConfirm() {
      this.$refs.registerItemsConfirm.show();
    },
    registerItems() {
      api.registerCustomRegistration(this.items, (data) => {
        this.items = [];
        this.totalRows = this.items.length;
        this.imported = false;
        this.hasErrors = true;
        this.confirmMessage = '登録完了しました。';
        this.$refs.messagePopup.show();
      });
    },
    addCellVariant() {
      this.hasErrors = false;
      if (this.items.length < 1) {
        this.hasErrors = true;
      }
      for (const v of this.items) {
        let hasError = false;
        const errorCells = [];

        if (v.errorCustomDate !== null && v.errorCustomDate === true) {
          errorCells.customBillingDate = 'danger';
          hasError = true;
        }
        if (v.errorCustomAmount !== null && v.errorCustomAmount === true) {
          errorCells.customs = 'danger';
          hasError = true;
        }
        if (v.errorTrackingNumber !== null && v.errorTrackingNumber === true) {
          errorCells.trackingNumber = 'danger';
          hasError = true;
        }
        if (hasError) {
          errorCells.status = 'danger';
          this.hasErrors = true;
        } else{
          if(v.status === 'WARN'){
            errorCells.status = 'warning';
          } else if(v.status === 'ERROR'){
            errorCells.status = 'danger';
            this.hasErrors = true;
          }
        }
        v._cellVariants = errorCells;
      }
    },
  },
};

</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}

.margin-left {
    margin-left: 1rem;
}
.margin-left-5 {
    margin-left: 5rem;
}

th.table-base {
  background-color: aliceblue!important;
}

th.table-ans {
  background-color: beige!important;
}

@media (min-width: 768px) {
  .table-right { text-align: right; }
}
</style>
